import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Paper, TextInput, PasswordInput, Button, Text, Center, Stack, Alert } from '@mantine/core'
import { IconShieldOff } from '@tabler/icons-react'
import { useAuth } from '@/context/AuthContext'

export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [forbidden, setForbidden] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  useEffect(() => {
    if (searchParams.get('error') === 'forbidden') {
      setForbidden(true)
    }
  }, [searchParams])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(email, password)
      navigate('/')
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'Нэвтрэхэд алдаа гарлаа')
    } finally {
      setLoading(false)
    }
  }

  return (
    <Center h="100vh" bg="gray.0">
      <Paper shadow="md" p="xl" w={400} radius="md">
        <Center mb="xs">
          <img src="/logo.png" alt="ARYA Admin" style={{ height: 40 }} />
        </Center>
        <Text size="sm" c="dimmed" ta="center" mb="lg">Админ самбар руу нэвтрэх</Text>

        {forbidden && (
          <Alert icon={<IconShieldOff size={18} />} color="red" mb="md" onClose={() => setForbidden(false)} withCloseButton>
            Хандах эрх хүрэлцэхгүй байна. Дахин нэвтэрнэ үү.
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <Stack>
            <TextInput
              label="Имэйл"
              placeholder="admin@arya.mn"
              value={email}
              onChange={(e) => setEmail(e.currentTarget.value)}
              required
            />
            <PasswordInput
              label="Нууц үг"
              placeholder="Нууц үг"
              value={password}
              onChange={(e) => setPassword(e.currentTarget.value)}
              required
            />
            {error && <Text size="sm" c="red">{error}</Text>}
            <Button type="submit" fullWidth loading={loading}>Нэвтрэх</Button>
          </Stack>
        </form>
      </Paper>
    </Center>
  )
}
